import React from "react";
import ViewIcon from "src/components/shared/icon/ViewIcon";
import useAppGlobal from "src/context/useAppGlobal";
import { v4 as uuid } from "uuid";
import WarehouseDistributionDetail from "../balance/WarehouseDistributionDetail";

export default function useWarehouseDistributionAction() {
  const { handleOpenDialog } = useAppGlobal();

  const onReview = (item) => {
    handleOpenDialog({
      title: "Chi tiết",
      content: <WarehouseDistributionDetail item={item} />,
      size: "md",
    });
  };

  const action = [
    {
      id: uuid(),
      icon: <ViewIcon />,
      onClick: (item) => onReview(item),
      type: "icon",
    },
  ];
  return { action };
}
